import React from 'react'
import { AdsenseProvider } from '@jelly/components'

export function WrapPageElement({ children, data }) {
	const adsenseData = {
		adsense: data?.props?.adsense,
		adsenseMobile: data?.props?.adsenseMobile,
	}
	return data ? <AdsenseProvider {...adsenseData}>{children}</AdsenseProvider> : children
}
